import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Button,
  Badge,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import React, { useState } from "react";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

export default function SetGoogleDocumentWithPopupId({
  googleDocId,
  onSave,
  processing = false,
}) {
  const [localGoogleDocumentId, setLocalGoogleDocumentId] = useState(
    googleDocId || ""
  );
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(localGoogleDocumentId);
    }
    handleClose();
  };

  const renderBadgeContent = () => {
    if (processing) {
      return <CircularProgress size={"10px"} color="secondary" />;
    }
    if (googleDocId) {
      return <CheckIcon sx={{ width: "10px" }} />;
    }
    return null;
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Select Google Doc ID</DialogTitle>
        <DialogContent>
          <TextField
            sx={{
              mt: 1,
            }}
            fullWidth
            label="Google Doc ID"
            value={localGoogleDocumentId}
            onChange={(event) => setLocalGoogleDocumentId(event.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setLocalGoogleDocumentId("")}>
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} color="error">
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSave} color="success">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton onClick={() => setOpen(true)}>
        <Badge badgeContent={renderBadgeContent()} color="primary">
          <FilePresentIcon />
        </Badge>
      </IconButton>
    </>
  );
}
